import React from 'react'

export const NotFound = () => (
  <>
    <h1>Sorry page not found</h1>
  </>
)
